import { Airport } from "shared/types/airportsTypes";

export const nationalOriginsData: Airport[] = [
  {
    description: "Altamira - Altamira (ATM), Brasil",
    name: "Altamira",
    code: "ATM",
  },
  {
    description: "Aracaju - Aracaju (AJU), Brasil",
    name: "Aracaju",
    code: "AJU",
  },
  {
    description: "Bagé - Com. Gustavo Kraemer (BGX), Brasil",
    name: "Bagé",
    code: "BGX",
  },
  {
    description: "Belém - Val De Cans (BEL), Brasil",
    name: "Belém",
    code: "BEL",
  },
  {
    description: "Belo Horizonte - Todos os aeroportos (BHZ), Brasil",
    name: "Belo Horizonte",
    code: "BHZ",
  },
  {
    description: "Boa Vista - Boa Vista (BVB), Brasil",
    name: "Boa Vista",
    code: "BVB",
  },
  {
    description: "Brasília - Brasília Intl (BSB), Brasil",
    name: "Brasília",
    code: "BSB",
  },
  {
    description: "Campina Grande - João Suassuna (CPV), Brasil",
    name: "Campina Grande",
    code: "CPV",
  },
  {
    description: "Campinas - Viracopos (VCP), Brasil",
    name: "Campinas",
    code: "VCP",
  },
  {
    description: "Campo Grande - Campo Grande Intl (CGR), Brasil",
    name: "Campo Grande",
    code: "CGR",
  },
  {
    description: "Campos - Bartolomeu Lisandro (CAW), Brasil",
    name: "Campos",
    code: "CAW",
  },
  {
    description: "Carajás - Carajás (CKS), Brasil",
    name: "Carajás",
    code: "CKS",
  },
  {
    description: "Belo Horizonte - Confins (CNF), Brasil",
    name: "Confins",
    code: "CNF",
  },
  {
    description: "Corumbá - Corumba Intl (CMG), Brasil",
    name: "Corumbá",
    code: "CMG",
  },
  {
    description: "Criciúma - Criciúma (CCM), Brasil",
    name: "Criciúma",
    code: "CCM",
  },
  {
    description: "Cruzeiro do Sul - Cruzeiro do Sul Intl (CZS), Brasil",
    name: "Cruzeiro do Sul",
    code: "CZS",
  },
  {
    description: "Cuiabá - M Rondon (CGB), Brasil",
    name: "Cuiabá",
    code: "CGB",
  },
  {
    description: "Curitiba - Afonso Pena (CWB), Brasil",
    name: "Curitiba",
    code: "CWB",
  },
  {
    description: "Florianópolis - Hercílio Luz (FLN), Brasil",
    name: "Florianópolis",
    code: "FLN",
  },
  {
    description: "Fortaleza - Pinto Martins (FOR), Brasil",
    name: "Fortaleza",
    code: "FOR",
  },
  {
    description: "Foz do Iguaçu - Cataratas (IGU), Brasil",
    name: "Foz do Iguaçu",
    code: "IGU",
  },
  {
    description: "Goiânia - Santa Genoveva (GYN), Brasil",
    name: "Goiânia",
    code: "GYN",
  },
  {
    description: "Ilhéus - Jorge Amado (IOS), Brasil",
    name: "Ilhéus",
    code: "IOS",
  },
  {
    description: "Imperatriz - Imperatriz (IMP), Brasil",
    name: "Imperatriz",
    code: "IMP",
  },
  {
    description: "João Pessoa - Castro Pinto (JPA), Brasil",
    name: "João Pessoa",
    code: "JPA",
  },
  {
    description: "Joinville - Lauro Carneiro de Loyola (JOI), Brasil",
    name: "Joinville",
    code: "JOI",
  },
  {
    description: "Juazeiro do Norte - Regional Do Cariri (JDO), Brasil",
    name: "Juazeiro do Norte",
    code: "JDO",
  },
  {
    description: "Londrina - Londrina (LDB), Brasil",
    name: "Londrina",
    code: "LDB",
  },
  {
    description: "Macaé - Macaé (MEA), Brasil",
    name: "Macaé",
    code: "MEA",
  },
  {
    description: "Macapá - Macapa Intl (MCP), Brasil",
    name: "Macapá",
    code: "MCP",
  },
  {
    description: "Maceió - Palmares (MCZ), Brasil",
    name: "Maceió",
    code: "MCZ",
  },
  {
    description: "Manaus - Eduardo Gomes (MAO), Brasil",
    name: "Manaus",
    code: "MAO",
  },
  {
    description: "Marabá - João Correa da Rocha (MAB), Brasil",
    name: "Marabá",
    code: "MAB",
  },
  {
    description: "Montes Claros - Montes Claros (MOC), Brasil",
    name: "Montes Claros",
    code: "MOC",
  },
  {
    description: "Natal - Governador Aluízio Alves Intl (NAT), Brasil",
    name: "Natal",
    code: "NAT",
  },
  {
    description: "Navegantes - Navegantes (NVT), Brasil",
    name: "Navegantes",
    code: "NVT",
  },
  {
    description: "Palmas - Palmas (PMW), Brasil",
    name: "Palmas",
    code: "PMW",
  },
  {
    description: "Parnaíba - Prefeito Dr. João Silva Filho (PHB), Brasil",
    name: "Parnaíba",
    code: "PHB",
  },
  {
    description: "Paulo Afonso - Paulo Afonso (PAV), Brasil",
    name: "Paulo Afonso",
    code: "PAV",
  },
  {
    description: "Pelotas - João Simões Lopes Neto (PET), Brasil",
    name: "Pelotas",
    code: "PET",
  },
  {
    description: "Petrolina - Petrolina Intl (PNZ), Brasil",
    name: "Petrolina",
    code: "PNZ",
  },
  {
    description: "Ponta Porã - Ponta Porã Intl (PMG), Brasil",
    name: "Ponta Porã",
    code: "PMG",
  },
  {
    description: "Porto Alegre - Salgado Filho (POA), Brasil",
    name: "Porto Alegre",
    code: "POA",
  },
  {
    description: "Porto Velho - Belmonte (PVH), Brasil",
    name: "Porto Velho",
    code: "PVH",
  },
  {
    description: "Recife - Guararapes Intl (REC), Brasil",
    name: "Recife",
    code: "REC",
  },
  {
    description: "Rio Branco - Plácido de Castro (RBR), Brasil",
    name: "Rio Branco",
    code: "RBR",
  },
  {
    description: "Rio de Janeiro - Todos os aeroportos (RIO), Brasil",
    name: "Rio de Janeiro",
    code: "RIO",
  },
  {
    description: "Salvador - Dep. Luís Eduardo Magalhães (SSA), Brasil",
    name: "Salvador",
    code: "SSA",
  },
  {
    description: "Santarém - Maestro Wilson Fonseca (STM), Brasil",
    name: "Santarém",
    code: "STM",
  },
  {
    description: "São Jose dos Campos - São Jose Dos Campos (SJK), Brasil",
    name: "São José dos Campos",
    code: "SJK",
  },
  {
    description: "São Luís - Tirirical (SLZ), Brasil",
    name: "São Luís",
    code: "SLZ",
  },
  {
    description: "São Paulo - Todos os aeroportos (SAO), Brasil",
    name: "São Paulo",
    code: "SAO",
  },
  {
    description: "Tabatinga - Tabatinga Intl (TBT), Brasil",
    name: "Tabatinga",
    code: "TBT",
  },
  {
    description: "Tefé - Tefé (TFF), Brasil",
    name: "Tefé",
    code: "TFF",
  },
  {
    description: "Teresina - Teresina (THE), Brasil",
    name: "Teresina",
    code: "THE",
  },
  {
    description: "Uberaba - Uberaba (UBA), Brasil",
    name: "Uberaba",
    code: "UBA",
  },
  {
    description: "Uberlândia - Ten. Cel. Aviador César Bombonato (UDI), Brasil",
    name: "Uberlândia",
    code: "UDI",
  },
  {
    description: "Uruguaiana - Ruben Berta (URG), Brasil",
    name: "Uruguaiana",
    code: "URG",
  },
  {
    description: "Vitória - Eurico Sales (VIX), Brasil",
    name: "Vitória",
    code: "VIX",
  },
];
